<script setup lang="ts">
    // @ts-expect-error raison: lib externe mal typée
    import { computed, reactive, ref, defineProps, defineEmits } from 'vue';
    import OnboardingGroupeItemDetailsModal from './OnboardingGroupeItemDetailsModal.vue';
    import { formatAmount } from '@/utils';
        import axios from 'axios';

    const props = defineProps({
        collectivite: { type: Object, default: null },
        isWidgetMode: { type: Boolean, default: true }
    })
    const emit = defineEmits(['completed']);
    const loading = ref(false);
    const errorMessage = ref('');
    const importFile = ref<File | null>(null);
    const importDatas = ref([] as Array<any>);
    const itemDetailsModalRef = ref<InstanceType<typeof OnboardingGroupeItemDetailsModal> | null>(null);
    const queryParams = reactive({
        pageNumber: 1
    });
    const pagination = reactive({
        total: 0,
        per_page: 5,
        last_page: 1
    });
    const paginatedImportDatas = ref([] as Array<any>);
    const selectedItems = ref([] as any[]);
    const areAllItemsSelected = computed(() => {
        return paginatedImportDatas.value.filter(i => !i.has_errors).length == selectedItems.value.length;
    });
    const collectivite = ref(props.collectivite);
    const sendKycEmail = ref(true);
    const loadingDownloadCsv = ref(false);

    async function downloadCsv() {
        try {
            loadingDownloadCsv.value = true;
            const response = await axios.get("/backoffice/onboarding/download_excel_template", { responseType: "blob" });
            const blob = new Blob([response.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
            const url = window.URL.createObjectURL(blob);

            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", "onboarding_groupe_template.xlsx");
            document.body.appendChild(link);
            link.click();
            link.remove();
        } catch (error) {
            console.error("Erreur de téléchargement :", error);
        } finally {
            loadingDownloadCsv.value = false;
        }
    }
    async function onCsvImportFileLoaded(event: Event) {
        const input = event.target as HTMLInputElement;
        if (input.files && input.files.length > 0) {

            selectedItems.value = [];
            importDatas.value = [];
            paginatedImportDatas.value = [];
            queryParams.pageNumber = 1;
            pagination.total = 0;

            const file = input.files[0];
            await doImportCsvImportFileAction(file);

            pagination.total = importDatas.value.length;
            pagination.last_page = Math.ceil(pagination.total / pagination.per_page);
            onPaginate(queryParams.pageNumber);
            input.value = '';
        }
    }
    async function doImportCsvImportFileAction(csvFile: File) {
        try {
            loading.value = true;
            errorMessage.value = '';
            importFile.value = null;
            importDatas.value = [];

            const formToUpload = new FormData();
            formToUpload.append("import_file", csvFile);
            const response = await axios.post(`/backoffice/onboarding/prepare_import_file`, formToUpload);
            importDatas.value = response.data;
            importFile.value = csvFile;
            selectedItems.value = importDatas.value.filter(i => !i.has_errors).map(i => i.data.guid);

        } catch (error: any) {
            errorMessage.value = error;
        } finally {
            loading.value = false;
        }
    }

    function showItemDetailsModal(dataRow: any) {
        if (itemDetailsModalRef.value) {
            itemDetailsModalRef.value.open(dataRow);
        }
    }

    function onPaginate(page: number) {
        queryParams.pageNumber = page;
        const start = (page - 1) * pagination.per_page;
        paginatedImportDatas.value =  importDatas.value.slice(start, start + pagination.per_page);
    }

    function handleCheckAll(_event: any) {
        const checked = _event.target.checked;
        if (checked) {
            selectedItems.value = paginatedImportDatas.value.filter(i => !i.has_errors).map(i => i.data.guid);
        } else {
            selectedItems.value = [];
        }
    }

    async function doImportSelectionAction() {
        const selectionDatas = importDatas.value.filter(i => selectedItems.value.includes(i.data.guid)).map(i => i.data);
        if (selectionDatas.length == 0) { return; }

        try {
            loading.value = true;
            errorMessage.value = '';
            const response = await axios.post('/backoffice/onboarding/import_file_datas', { import_datas: selectionDatas, send_kyc_email: sendKycEmail.value, collectivite_id: collectivite.value.id });
            emit('completed', response.data);
        } catch(error: any) {
            errorMessage.value = error;
        } finally {
            loading.value = false;
        }
    }

    
</script>

<template>
    <div>
        

        <div class="px-8 py-7 s20" :class="{'widget': isWidgetMode}">

            <div class="s14_mobile">
                <h2 class="secondary-font gap-4 mt-2 mb-2">
                    Onboarding groupé - Création de compte en masse
                </h2>
                <p class="mb-0">Format de fichier supporté: CSV. Taille max: 50MB.</p>
            </div>
            <div class="s6_mobile">
                <custom-button :loading="loadingDownloadCsv" type="button" :classesList="'btn black stroke w-100 flex-center my-2'" @click="downloadCsv">
                    <img src="/icons/icon-telecharger.svg" class="btn-icon icon-neutral" alt="" />
                    <span>Modèle de fichier EXCEL</span>
                </custom-button>
            </div>

            <div class="clear-both h-0"></div>

            <div class="form-field-floating reactive active my-4" v-if="collectivite">
                <input type="text" class="form-input" v-model="collectivite.nom" name="collectivite_nom" id="collectivite_nom" placeholder="" :readonly="true">
                <label for="collectivite_nom">Collectivité <b class="color-danger">*</b></label>
            </div>

            <!--Upload file-->
            <label for="file-upload2" class="custom-upload my-5"><!--active-->
                <div class="custom-upload-st2">
                    <input id="file-upload2" name="file-upload" type="file" accept=".xlsx" @change="onCsvImportFileLoaded">
                    <div class="s4 custom-upload-img">.XLSX</div>
                    <div class="s12">
                        <span id="file-upload-title" class="custom-upload-text">Charger le fichier EXCEL</span> <b class="color-danger">*</b><br>
                        <span id="file-upload-title" class="custom-upload-text">Uploader le doc</span>
                    </div>
                    <div class="s4 right"><img src="/icons/icon-upload.svg" class="custom-upload-icon" />
                    </div>
                </div>
            </label>

            <div class="clear-both h-10"></div>

            <div style="display: flex; justify-content: center" v-if="loading">
                <div class="loader dark"></div>
            </div>
            <div class="py-6 s20" :class="{'widget': isWidgetMode}" v-if="!loading && importFile">
                <h2 class="secondary-font gap-4 mt-0 mb-5 px-6">
                    {{ importFile.name }}
                </h2>
                <table class="table separator skin1 sm selection">
                    <!-- selection skin1 skin2 (bg1 bg2 bg3)  (skin3 rounded) sm  -->
                    <thead>
                        <tr>
                            <th>
                                <label class="btn-circle" for="check_all">
                                    <input type="checkbox" id="check_all" :checked="areAllItemsSelected" @change="handleCheckAll" />
                                </label>
                            </th>
                            <th></th>
                            <th>
                                <img src="/icons/icon-filter-up.svg" class="size-xxs mt--1" alt="" /> 
                                Nom
                            </th>
                            <th>
                                <img src="/icons/icon-filter-down.svg" class="size-xxs mt--1" alt="" />
                                Prénoms
                            </th>
                            <th>
                                <img src="/icons/icon-filter-none.svg" class="size-xxs mt--1" alt="" />
                                Salaire brut
                            </th>
                            <th>
                                <img src="/icons/icon-filter-up.svg" class="size-xxs mt--1" alt="" />
                                Quotité cessible
                            </th>
                            <th>
                                <img src="/icons/icon-filter-up.svg" class="size-xxs mt--1" alt="" />
                                Contact
                            </th>
                            <th class="flex-right"></th>
                        </tr>
                    </thead>
                    <tbody>
                        <template v-for="(dataRow, index) in paginatedImportDatas" :key="'row_' + index">
                            <tr class="text-grey-700 over-effect"><!-- over-effect active-->
                                <td class="selection-item">
                                    <label class="btn-circle" :for="'item_check_' + index">
                                        <input type="checkbox" name="selectedItems[]" :id="'item_check_' + index" :value="dataRow.data.guid" v-model="selectedItems" :disabled="dataRow.has_errors" />
                                    </label>
                                </td>
                                <td class="font-black">
                                    <img src="/icons/icon-data.svg" class="size-medium " />
                                    <img v-if="dataRow.has_errors" style="height: 16px;margin-left: 5px; filter:invert(19%) sepia(93%) saturate(4156%) hue-rotate(355deg) brightness(101%) contrast(105%)" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAAACXBIWXMAAAsTAAALEwEAmpwYAAAEB0lEQVR4nO2dTahWRRjHf5ofmF+YYooomopIghC4EAwiaeEiF6KgkpsSEj9QFLJNmYIaGNUiDApyVaKibkw3akSWJHEVhEoqlURDUbPMrPQ2MjAnRDrjfc/MnJk55/nBf3PvZZ7n/+d97znvfWbOBUEQBEEQBEEQBMGJfsBS4Bhw1egL4EXzPcEDw4HjgCrRN8DI2E3mTh+gyxLy/WE/ErvZnFnZg5AL6Z8VKvCY+V3c06CvAyOqFGo773cQcqHtsZvOjSeBOxWCvgtMj918TnxWIeRC+ravV2wDObDAIeRC82ObSJ0BwDkPQf8MPBrbTMq87iHkQq/FNpMqY4A/PAb9JzAutqkU+cRjyIU+jm0qNWYC/wYIWq/5dGxzqdAbOBEg5EJdpkbrWRow5EIv0XIGA5dqCPoyMJQW81YNIRfaRkuZBPxVY9B/A1NoIZ/WGHKhA7SM5yKEXGgOLaEv8H3EoH8A+tMC1kUMudBaGs5I4NcEgv4NGEWD+TCBkAt9QEN5CuiuGMpyYFiJlldcs9v01Dg+d3j1vWxZd5nDul82bey1yPFtvtqy9hrHtRfSoPHUeccw1lvWf9Vx7QvAQBrARscgtDZY1n/Dw/p6jawZC9zyEMQWS42tnsZe48mY3R5CUMDblhrveKqxi0yZ5XE8td3z1rEyPUNm9DZbaX0F8JGl1g6PdU7ltv3X5d5W/Y/0hLyMnZ5r2e7Zk0J/Wrvi2fw+S739nmtdM6cMkuddz8YVcNBS71CAevoCmzRTgX8CGD8aaOdpmfSW4WkkTIhXlwK+stS0HSRy0WESZW4gw8psginjZMC6z5MY+qzfmYCGv7XU/i5g3R9TG3utD2hWAWcttX3sp7bpFRLhceBGYLOXLPV/CVz7d2A0CeDzk5myHG0ro44ZpPYYlRkO4ynVgfQt45slCnE7+aC6jdco9DInoFRLdDzW2GtJAuZVzXqh7pAHARcTMK5qlr7wDqkz6M0JmFaRpL3XwhPA7QQMq0jS238n1xH03kgGb5nR2Eaj3Z7mkb7/bOuFZyMZO2/eSQ8y0ZySjdHT7JBPgzkdydQiS1+LI/V02mTinRWRDClggqWv0RH70plEfRqMb4239DYqYl/XTDbeeC+iGfWQ/XGu+/pcpbPxwrSKT4PxfTGcWHKyK9bF0PvY63BkI+q+bVt7gE1Ge8zXVAI64hryvARMqEyks6qEHuH8lIABlYnOVh171XEYXjVMOrOOOZZA4yoz6aMaHXM9gcZVZtL31R1zM4HGVWbS5xc75usEGlcZjrs6ZlUCjavMVOmJv/0Db7dSDdNJl6ez62fRSdj0KGSdlRP9zFtC//6RCyT/6abZ5aqzkf8zIAiCIAiCIAiCIAgCbeIeKS6tsZ2f6DkAAAAASUVORK5CYII=" alt="error--v1">
                                    <img v-if="!dataRow.has_errors" style="height: 16px;margin-left: 5px; filter: invert(19%) sepia(93%) saturate(4156%) hue-rotate(130deg) brightness(101%) contrast(105%)" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAABTklEQVR4nK2VPUoEQRCFv8jYwEBdxauIkeK699BZEwMDb2EkiicwmsC/SwhG/oGZqaCrBrJKS0nZ9EpP/808eDBM17zqqa56DWEsAkPgArgF3pXyfA5UwAIF6AGHwBgwEX4DJ8BSqvgAGCUIm3+UbzZi4tu6o1xx4/yNlNSLNeCrhbhxkgx8NS8pi2ngKzDnJjjuUNwopUlsK7YpzSdw7Xk/1sr8Hkqp+AewrBu99KxvoQPTVrwHPHliTmXxoVB8RcVngZuGuDsC3XMFTAN7kZ2HNjiKJZhSod0CcZvgPhBQO0l2MsWNmmL0kGsnSY64PeQqIbDWJDniwk3Uz1Ns+RF4zhC3gyY4KpwFE+CB60XzHZvdi87HBFY7tOt+050w7ODCqYigr35eUpb1mPgfZoD9xO6SGPH+iQsmFdJm0stnamhvSnmWIZI124o+/AB50KFiqZyaQQAAAABJRU5ErkJggg==" alt="external-verified-check-circle-for-approved-valid-content-basic-bold-tal-revivo">
                                </td>
                                <td class="font-bold">{{ dataRow.data.nom }}</td>
                                <td>{{ dataRow.data.prenom }}</td>
                                <td class="font-bold">{{ formatAmount(dataRow.data.salaire) }} F CFA</td>
                                <td class="font-bold">{{ formatAmount(dataRow.data.quotite_cessible_montant) }} <br /> ({{ dataRow.data.quotite_cessible_pourcent }}%)</td>
                                <td class="text-sm text-grey-500">{{ dataRow.data.telephone }} <br /> {{ dataRow.data.email }}</td>
                                <td class="flex-right">
                                    <button class="btn white2 collapse-open-table" @click="showItemDetailsModal(dataRow)"><!--white2-->
                                        <img src="/icons/icon-list.svg" class="btn-icon" alt="" />
                                        <span>Plus</span>
                                    </button>
                                </td>
                            </tr>
                        </template>
                    </tbody>
                </table>

                <div class="clear-both h-15"></div>

                <div class="s14_mobile px-3">
                    <custom-pagination v-model="queryParams.pageNumber" :total="pagination.total" :per-page="pagination.per_page" :last_page="pagination.last_page" @update:modelValue="onPaginate" />
                </div>
                <div class="s6_mobile px-4">
                    <!--<div class="card-check lg single">
                        <label class="form-check-label">
                            <div class="card-check-text">
                                <input class="form-check-input left" type="checkbox" name="send_kyc_email" id="send_kyc_email" value="1" v-model="sendKycEmail" />
                                <h6 class="font-semibold mt-1 mb-2 align-right">Envoyer le mail d'invitation ?</h6>
                            </div>  
                        </label>
                    </div>-->
                    <custom-button type="button" :classesList="'btn lg w-100 flex-center my-2'" v-if="selectedItems.length > 0" :disabled="selectedItems.length == 0" @click="doImportSelectionAction">
                        <img src="/icons/icon-telecharger.svg" class="btn-icon" alt="" />
                        <span>Importer ({{ selectedItems.length }})</span>
                    </custom-button>
                </div>

            </div>
            <div v-if="errorMessage" class="alert alert-danger mb-4">{{ errorMessage }}</div>
        </div>

        <onboarding-groupe-item-details-modal ref="itemDetailsModalRef" />
    </div>
</template>
